<template>
    <section id="v-panel-content">
        <slot />

        <div class="panel-header d-flex">
            <div class="operat-left">
                <span class="label">{{ $TL.filterResults }}：</span>
                <v-btn
                    class="select-all-btn gradient-bg"
                    @click="is_all_select"
                >
                    <span v-if="selectAllTextShow"
                        >{{ !isAllSelect ? $TL.selectAll : $TL.unselectAll }}
                    </span>
                </v-btn>
                <v-select
                    class="card-size-select"
                    v-model="cardSizeSelect.value"
                    :items="cardSizeSelect.items"
                    item-text="name"
                    item-value="value"
                    :label="$TL.size"
                    attach
                    outlined
                    multiple
                    :menu-props="{ 'nudge-top': -40 }"
                    @change="
                        change_select_value();
                        trigger_schema();
                    "
                ></v-select>
                <v-menu
                    v-if="isFilterBtn"
                    offset-y
                    attach
                    class="latest-update-filter"
                    :close-on-content-click="closeType"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="filter-btn"
                            v-bind="attrs"
                            v-on="on"
                            :ripple="false"
                            @click="open_select"
                        >
                            {{ $TL.filter }}
                            <v-icon>mdi-menu-down</v-icon>
                        </v-btn>
                    </template>
                    <search-categray
                        ref="searchCategray"
                        @updateCategory="update_category"
                    />
                    <v-btn
                        class="accep-btn gradient-bg"
                        @click="filter_latest_data"
                        >{{ $TL.agree }}</v-btn
                    >
                </v-menu>
            </div>
            <div class="operat-right">
                <div class="sort-filter d-flex">
                    <template v-if="$store.state.global.routerName === 'home'">
                        <v-select
                            v-if="isShowProducerSelect"
                            v-model="producerSelect.value"
                            :items="producerSelect.items"
                            item-text="name"
                            item-value="value"
                            :label="$TL.all"
                            :outlined="false"
                            attach
                            dense
                            :menu-props="{ 'nudge-top': -30 }"
                            @change="
                                change_select_value();
                                trigger_schema();
                            "
                        ></v-select>
                        <v-select
                            v-model="checkConditionSelect.value"
                            :items="checkConditionSelect.items"
                            item-text="name"
                            item-value="value"
                            :label="$TL.newestUpload"
                            attach
                            dense
                            :menu-props="{ 'nudge-top': -30 }"
                            @change="
                                change_select_value();
                                trigger_schema();
                            "
                        ></v-select>
                    </template>
                    <template v-else>
                        <v-select
                            v-model="favoritePictureSelect.value"
                            :items="favoritePictureSelect.items"
                            item-text="name"
                            item-value="value"
                            :label="$TL.newestFavorite"
                            attach
                            dense
                            :menu-props="{ 'nudge-top': -30 }"
                            @change="
                                change_select_value();
                                trigger_schema();
                            "
                        ></v-select>
                    </template>
                    <div class="view-change-box d-flex">
                        <v-btn
                            v-for="(className, i) in layoutClassName"
                            :key="i"
                            :ripple="false"
                            :class="[className, i === index && 'active']"
                            @click="update_user_view(className, i)"
                        >
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>

        <v-picture-wrapper :class="layoutStyle" ref="vPictureWrapper" />
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_storage, timeout } from "@/utils/util";
import searchCategray from "@/components/search-categray/index";
export default {
    name: "v-panel-content",
    props: {
        data: {
            type: Object,
            required: false,
        },
    },
    components: { searchCategray },
    data() {
        return {
            isShowsizeFilterBox: false,
            homePage: true,
            isShowProducerSelect: false,
            closeType: false,
            layoutStyle: "layout-large-without-meta",
            index: 1,
            fnames: [],
            layoutClassName: [
                "large-with-meta",
                "large-without-meta",
                "small-with-meta",
                "small-without-meta",
            ],
            selectAllTextShow: true,

            cardSizeSelect: {
                value: [],
                items: [
                    { name: this.$TL.horizontalPlate, value: "H" },
                    { name: this.$TL.squarePlate, value: "S" },
                    { name: this.$TL.verticalPlate, value: "V" },
                ],
            },
            producerSelect: {
                value: "all",
                items: [
                    { name: this.$TL.all, value: "all" },
                    { name: this.$TL.wmArtist, value: "wm" },
                    { name: this.$TL.tpzArtist, value: "tp" },
                ],
            },
            checkConditionSelect: {
                value: "createdTime",
                items: [
                    { name: this.$TL.newestUpload, value: "createdTime" },
                    { name: this.$TL.mostLikes, value: "likes" },
                    { name: this.$TL.mostDownload, value: "downloads" },
                ],
            },
            favoritePictureSelect: {
                value: "favorited_at",
                items: [
                    { name: this.$TL.newestFavorite, value: "favorited_at" },
                    { name: this.$TL.newestUpload, value: "createdTime" },
                    { name: this.$TL.fromAtoZ, value: "name" },
                ],
            },
        };
    },

    created() {
        //  筛选条件初始化
        this.change_select_value();
        this.is_show_producer_select();
    },
    computed: {
        ...mapState("favorites", ["favoritesId"]),
        ...mapState("search", ["searchCondition"]),
        ...mapState("triggerEvtents", ["initSearchCondition"]),
        ...mapState("mixins", ["isAllSelect", "isFilterBtn"]),
        ...mapState("global", ["isNewBeveliver"]),
    },
    watch: {
        //  初始化筛选条件
        initSearchCondition() {
            this.cardSizeSelect.value = [];
            this.producerSelect.value = "all";
            this.checkConditionSelect.value = ["createdTime"];
            this.favoritePictureSelect.value = "favorited_at";
            this.change_select_value();

            //  重置tags 选中状态
            this.$store.state.mixins.isTagsActive = -1;
        },
    },
    mounted() {},
    methods: {
        ...mapMutations("search", [
            "updateSearchCondition",
            "updatePictureSize",
            "updatePictureProducer",
            "updateCheckCondition",
            "updateFavoritePictureSort",
            "updateFilterCondition",
        ]),
        ...mapMutations("triggerEvtents", ["updateGetSchemaData"]),
        ...mapMutations("mixins", ["updateAllSelect"]),

        //  全选
        async is_all_select() {
            this.$store.state.mixins.isAllSelect =
                !this.$store.state.mixins.isAllSelect;
            //  用js 处理，速度快
            let pictureItemInput = document.querySelectorAll(".picture-item");

            if (this.isAllSelect) {
                [...pictureItemInput].map((item) => {
                    if (!item.className.includes("checked")) {
                        item.classList.add("checked");
                    }
                });
                this.$refs.vPictureWrapper.select_all_fn();
            } else {
                [...pictureItemInput].map((item) => {
                    if (item.className.includes("checked")) {
                        item.classList.remove("checked");
                    }
                });
                this.$refs.vPictureWrapper.deselect_all_fn();
            }

            //  解决新人账号取消全选文字不能翻译问题
            if (this.isNewBeveliver) {
                this.selectAllTextShow = false;
                await timeout(60);
                this.selectAllTextShow = true;
            }
        },

        //  切换视图
        update_user_view(className, key) {
            this.index = key;
            this.layoutStyle = `layout-${className}`;
        },

        change_select_value() {
            this.updatePictureSize(this.cardSizeSelect.value);
            this.updatePictureProducer(this.producerSelect.value);
            this.updateCheckCondition(this.checkConditionSelect.value);
            this.updateFavoritePictureSort(this.favoritePictureSelect.value);
        },

        trigger_schema() {
            this.updateGetSchemaData();
        },
        //  判断登录用户，展示图片制作方
        is_show_producer_select() {
            let role = get_storage("user-role");
            if (role === "user-meigong" || role === "user-manager") {
                this.isShowProducerSelect = true;
            }
        },
        // 接受筛选类别返回的数据
        update_category(namesArry) {
            this.fnames = namesArry;
        },
        // 打开筛选条件弹框
        async open_select() {
            this.closeType = false;
            await timeout(200);
            this.$refs.searchCategray.open_select();
        },
        //  过滤最新数据
        filter_latest_data() {
            this.closeType = true;
            //  当前数据类型是否为按语言
            this.$P.schemaType = "latestUpdate";
            this.updateFilterCondition(this.fnames);
            this.updateGetSchemaData();
        },
    },
};
</script>

<style lang="scss">
#v-panel-content {
    width: 100%;
    padding: 0 20px;
    transition: 0.32s cubic-bezier(0.4, 0, 0.2, 1) 0.06s;

    &[data-salce="true"] {
        padding-left: 280px;
    }

    .container {
        width: 100%;
    }

    .panel-header {
        padding: 10px 0;
        justify-content: space-between;

        .v-menu__content {
            width: 120px;
        }
    }

    .operat-left {
        position: relative;
        z-index: 30;
        @include flex(center);

        .label {
            font-size: 14px;
        }

        .v-btn {
            padding: 8px 13px;
        }

        .select-all-btn {
            border-radius: $border-radius;
            margin-right: 16px;
            min-height: 36px;
            min-width: 60px;
            transition: all 0.3s ease;

            span {
                color: $color-white;
            }
        }

        .theme--light.v-label {
            color: #3c4043;
        }

        .filter-btn {
            border: 1px solid #00a3ff;
            border-radius: 4px;
            margin-left: 16px;
            padding: {
                top: 6px;
                bottom: 5px;
                right: 8px;
            }

            &[aria-expanded="true"] {
                box-shadow: inset 0 0 0 1px #00a3ff;
                span {
                    color: #00a3ff;
                }

                i {
                    color: #1976d2 !important;
                }
            }

            .v-icon {
                padding-left: 4px;
                color: #00a3ff;
            }
        }

        .card-size-select {
            border-color: #00a3ff;

            .v-select__slot {
                padding: 6px 0;
                label,
                .v-select__selection {
                    font-size: 14px;
                }

                .v-input__append-inner .v-icon,
                .v-select__selection {
                    color: #00a3ff;
                }
            }
        }

        .v-text-field--outlined .v-input__slot fieldset {
            color: #00a3ff !important;
            caret-color: #00a3ff !important;
        }
    }

    .latest-update-filter {
        .v-menu__content {
            background-color: #fff;
            width: 350px;
        }

        .search-categray .select-list {
            height: 330px;
        }
        .accep-btn {
            padding: 7px 16px;
            border-radius: 32px;
            margin: 8px 12px 8px auto;
        }
    }

    .operat-right {
        .sort-filter {
            z-index: 300;

            .v-label {
                top: 0;
                color: $color-font;
            }
        }
    }

    .sort-filter {
        position: relative;
        align-items: center;

        .v-input {
            margin-right: 20px;

            .v-input__slot {
                &::before,
                &::after {
                    display: none;
                }
            }
        }
    }

    .sort-btn {
        span {
            font-size: 14px;
        }
    }

    .card-size-select,
    .sort-filter {
        .v-text-field__details {
            display: none;
        }
    }

    .operat-state-select {
        margin-left: 40px;
    }

    .size-filter-box {
        .option-box {
            right: -60px;
            width: 130px;

            padding: {
                top: 16px;
                bottom: 4px;
            }

            .select {
                li {
                    span {
                        font-size: 14px;
                        padding-left: 24px;
                    }
                }
            }
        }
    }

    .sort-project-box {
        .option-box {
            left: 0;
            width: 106px;
            padding: 4px 0 6px 0;

            .select {
                li {
                    font-size: 14px;
                    padding: 8px 16px;
                    cursor: pointer;

                    &:hover,
                    &.active {
                        color: $color-brand;
                    }
                }
            }
        }
    }

    .make-group {
        margin-right: 50px;
    }

    .view-change-box {
        .v-btn {
            width: 36px;
            height: 32px;
            background-color: transparent;
            border-radius: $border-radius;
            transition: all 0.35s ease;

            span {
                display: inline-block;
                position: relative;
                border: 2px solid #999999;
                border-radius: 2px;
                transition: all 0.35s ease;
            }

            &:hover,
            &.active {
                background-color: #d6f0ff;
                span {
                    border-color: $color-brand;
                    &::after {
                        background-color: $color-brand;
                    }
                }
            }
        }

        .small-without-meta,
        .large-without-meta {
            span {
                margin-top: -2px;
                &:after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 2px;
                    background-color: #999999;
                    margin-top: 100%;
                }
            }
        }
        .small-with-meta,
        .small-without-meta {
            span {
                width: 14px;
                height: 10px;
            }
        }

        .large-with-meta,
        .large-without-meta {
            span {
                width: 18px;
                height: 13px;
            }
        }
    }
}

.user-new-believer {
    .card-size-select {
        .v-menu__content {
            min-width: 200px !important;
        }
        .v-list-item__content {
            .v-list-item__title {
                font {
                    font-size: 14px;
                }
            }
        }
    }

    .operat-left {
        .label {
            margin-right: 10px;
        }
    }
}
</style>
